import { render, staticRenderFns } from "./AnimatedTransition.vue?vue&type=template&id=2cb948dc&lang=pug"
import script from "./AnimatedTransition.vue?vue&type=script&lang=ts"
export * from "./AnimatedTransition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports